/* ==========================================================================
   Wild Touch Engraving - dust field

   Gold flecks hanging in workshop air. Three depth layers drifting at
   different rates, gently repelled by the pointer. Full tier only: on
   standard the CSS gradient mesh in motion.css takes over, on minimal
   nothing moves at all.

   Adaptive: if frame time exceeds 20ms across 60 frames the particle count
   is halved once, then again, down to a floor of 30.
   ========================================================================== */

(function () {
  'use strict';

  if (document.documentElement.getAttribute('data-motion-tier') !== 'full') return;

  var host = document.querySelector('[data-ambient-field]');
  if (!host) return;

  var canvas = host.querySelector('canvas');
  var ctx = canvas.getContext('2d');
  var dpr = Math.min(window.devicePixelRatio || 1, 1.5);

  var W = 0;
  var H = 0;
  var particles = [];
  var count = Math.round(
    Math.min(140, Math.max(60, (window.innerWidth * window.innerHeight) / 16000))
  );
  var pointer = { x: -9999, y: -9999 };
  var running = false;
  var slowFrames = 0;
  var last = 0;

  var tint = getComputedStyle(document.documentElement).getPropertyValue('--gold-rgb').trim() || '202, 153, 59';

  function size() {
    W = window.innerWidth;
    H = window.innerHeight;
    canvas.width = W * dpr;
    canvas.height = H * dpr;
    canvas.style.width = W + 'px';
    canvas.style.height = H + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  function seed() {
    particles = [];
    for (var i = 0; i < count; i++) {
      var depth = 0.35 + Math.random() * 0.65;
      particles.push({
        x: Math.random() * W,
        y: Math.random() * H,
        r: depth * (0.6 + Math.random() * 1.3),
        vx: (Math.random() - 0.5) * 0.12 * depth,
        vy: -(0.08 + Math.random() * 0.22) * depth,
        depth: depth,
        a: 0.15 + depth * 0.4
      });
    }
  }

  size();
  seed();
  window.addEventListener(
    'resize',
    function () {
      size();
      seed();
    },
    { passive: true }
  );

  document.addEventListener(
    'pointermove',
    function (e) {
      pointer.x = e.clientX;
      pointer.y = e.clientY;
    },
    { passive: true }
  );

  document.addEventListener('pointerleave', function () {
    pointer.x = pointer.y = -9999;
  });

  function frame(now) {
    if (document.hidden || !visible) {
      running = false;
      return;
    }

    if (last) {
      var dt = now - last;
      if (dt > 20) slowFrames++;
      else slowFrames = Math.max(0, slowFrames - 1);
      if (slowFrames > 60 && count > 30) {
        count = Math.max(30, Math.round(count / 2));
        seed();
        slowFrames = 0;
      }
    }
    last = now;

    ctx.clearRect(0, 0, W, H);

    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.x += p.vx;
      p.y += p.vy;

      var dx = p.x - pointer.x;
      var dy = p.y - pointer.y;
      var d2 = dx * dx + dy * dy;
      if (d2 < 14400) {
        var d = Math.sqrt(d2) || 1;
        var push = (1 - d / 120) * 0.7;
        p.x += (dx / d) * push;
        p.y += (dy / d) * push;
      }

      /* seamless: a fleck that leaves the frame re-enters from the far edge */
      if (p.y < -6) {
        p.y = H + 6;
        p.x = Math.random() * W;
      }
      if (p.x < -6) p.x = W + 6;
      if (p.x > W + 6) p.x = -6;

      ctx.beginPath();
      ctx.fillStyle = 'rgba(' + tint + ',' + p.a + ')';
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
    }

    requestAnimationFrame(frame);
  }

  var visible = true;

  function start() {
    if (running || document.hidden || !visible) return;
    running = true;
    last = 0;
    requestAnimationFrame(frame);
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) running = false;
    else start();
  });

  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting;
      if (visible) start();
      else running = false;
    }).observe(host);
  }

  start();
})();
